import { render, staticRenderFns } from "./ModalProtocolResult.vue?vue&type=template&id=2aae2f52&scoped=true"
import script from "./ModalProtocolResult.vue?vue&type=script&lang=js"
export * from "./ModalProtocolResult.vue?vue&type=script&lang=js"
import style0 from "./ModalProtocolResult.vue?vue&type=style&index=0&id=2aae2f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aae2f52",
  null
  
)

export default component.exports